import store from "../store";
import Constants from "../config/constants";
import { serviceGetNegativeWallet } from "../services/NegativeWallet.service";

export const FETCH_INIT = "FETCH_INIT_NEGATIVE_WALLET";
export const FETCHED = "FETCHED_NEGATIVE_WALLET";
export const FETCHED_FAIL = "FETCHED_FAIL_NEGATIVE_WALLET";
export const FETCHED_FILTER = "FETCHED_FILTER_NEGATIVE_WALLET";
export const FETCH_NEXT = "FETCH_NEXT_NEGATIVE_WALLET";
export const FILTER = "FILTER_NEGATIVE_WALLET";
export const RESET_FILTER = "RESET_FILTER_NEGATIVE_WALLET";
export const SET_SORTING = "SET_SORTING_NEGATIVE_WALLET";
export const SET_FILTER = "SET_FILTER_NEGATIVE_WALLET";
export const SET_PAGE = "SET_PAGE_NEGATIVE_WALLET";
export const CHANGE_PAGE = "CHANGE_PAGE_NEGATIVE_WALLET";
export const CHANGE_STATUS = "CHANGE_STATE_NEGATIVE_WALLET";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_NEGATIVE_WALLET";
export const CREATE_DATA = "CREATE_NEGATIVE_WALLET";
export const UPDATE_DATA = "UPDATE_NEGATIVE_WALLET";
export const DELETE_ITEM = "DELETE_NEGATIVE_WALLET";

export function actionFetchNegativeWallet(index = 1, sorting = {}, filter = {}) {
  const request = serviceGetNegativeWallet({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  });
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionSetPageNegativeWallet(page) {
  const stateData = store.getState().negative_wallet;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;

  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchNegativeWallet(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
      })
    );
  }

  console.log(currentPage, totalLength);
  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}
